export default "__VITE_ASSET__DA768xIi__"